import React from "react";
import { useSelector } from "react-redux";
import TopEventDetails from "../../card/TopEventDetails";

const TopEvents = () => {
  const { eventManagement } = useSelector((state) => state);
  return (
    <>
      <div class="flex items-center space-x-4 mt-5">
        <h2 class="text-sm font-bold text-gray-200 uppercase">
          Top <span class="dark:text-primary">Events</span>
        </h2>
        <div class="flex-grow border-t border-gray-700"></div>
      </div>
      <div className=" mt-6">
        <div className="grid sm:grid-cols-2 2xl:grid-cols-3 gap-4 dark:bg-[#121415]">
          {eventManagement?.all?.data
            ?.filter?.((el) => el?.class === "top")
            ?.map((event, index) => (
              <TopEventDetails key={index} event={event} />
            ))}
        </div>
      </div>
    </>
  );
};

export default TopEvents;
